/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { RiDeleteBinLine } from 'react-icons/ri';
import { MdEdit } from 'react-icons/md';
import { GiCancel } from 'react-icons/gi';
import { useRoleUser } from 'src/hooks/query/usersByRole';
import { SlotsByDate } from '../../types';

interface SlotsFilterType {
  interviewer: number;
}

interface SlotsFilterProps {
  slots: SlotsByDate;
  openSlotsEnabled: boolean;
  showReschedulePopup: (id: number) => void;
  deleteInterviewSlot: (slotId: number) => Promise<void>;
}

const SlotsFilter = function SlotsFilter(props: SlotsFilterProps) {
  const {
    slots, openSlotsEnabled, showReschedulePopup, deleteInterviewSlot,
  } = props;
  const validationSchema = yup.object().shape({
    interviewer: yup
      .number()
      .typeError('Select interview position to change')
      .required('Interview Position required'),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const methods = useForm<SlotsFilterType>({
    resolver,
  });

  const { watch } = methods;

  const { userByRoleOptionsWithEmail, usersLoading } = useRoleUser({
    roleNameList: 'ATSInterviewer',
  });

  const [filteredSlots, setFilteredSlots] = useState<SlotsByDate>();

  const handleChangeInterviewer = (id: number) => {
    if (id) {
      const newFilteredSlots: SlotsByDate = {};

      Object.keys(slots).forEach((date) => {
        const filteredSlotsForDate = slots[date].filter(
          (slot) => slot.interviewerId === id,
        );

        if (filteredSlotsForDate.length > 0) {
          newFilteredSlots[date] = filteredSlotsForDate;
        }
      });

      setFilteredSlots(newFilteredSlots);
    } else {
      setFilteredSlots(slots);
    }
  };

  useEffect(() => {
    const id = watch('interviewer');
    handleChangeInterviewer(id);
  }, [watch('interviewer'), slots]);

  return (
    <FormProvider {...methods}>
      <form className="py-5">
        <div>
          <div className="px-10">
            <RHFAutoComplete
              name="interviewer"
              control={methods.control}
              options={userByRoleOptionsWithEmail}
              loading={usersLoading}
              placeholder="Select interviewer"
            />
          </div>
          <div className="flex flex-col my-4 gap-4 h-[60vh] px-10 overflow-y-auto">
            {(filteredSlots && Object.keys(filteredSlots).length !== 0) ? (
              Object.keys(filteredSlots)?.map((date) => (
                <div key={date} className="flex flex-col">
                  <div className="flex justify-between items-center gap-2 font-semibold">
                    <div className="border-[#4D586A] border-solid h-[1px] w-[30%]" />
                    <div className="text-[#4D586A]">{date}</div>
                    <div className="border-[#4D586A] border-solid h-[1px] w-[30%]" />
                  </div>
                  <div className="flex flex-col gap-1">
                    {filteredSlots[date].map((slot) => (
                      <div
                        key={slot.id}
                        className="flex justify-center group gap-2 py-1 text-[#4D586A] hover:bg-[#4d586a1d] hover:cursor-pointer rounded-2xl transition-transform"
                      >
                        <div>{slot.startTime}</div>
                        <div>-</div>
                        <div>{slot.endTime}</div>
                        <div>{slot.timeZone}</div>
                        {openSlotsEnabled ? (
                          <Tooltip title="delete slot">
                            <div
                              className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xl text-secondary hover:text-[#4D586A]"
                              onClick={() => deleteInterviewSlot(slot.id)}
                            >
                              <RiDeleteBinLine />
                            </div>
                          </Tooltip>
                        ) : (
                          <>
                            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xl text-secondary hover:text-[#4D586A]">
                              <Tooltip title="reschedule interview">
                                <div
                                  className="cursor-pointer"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    showReschedulePopup(slot.id);
                                  }}
                                >
                                  <MdEdit />
                                </div>
                              </Tooltip>
                            </div>
                            <Tooltip title="cancel interview">
                              <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xl text-secondary hover:text-[#4D586A]">
                                <GiCancel />
                              </div>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-[#4D586A] font-semibold">No Slots Found</div>
            )}
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default SlotsFilter;
